module.exports = __webpack_public_path__ + "static/img/The Emperor.86f9057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Emperor.jpg
// module id = 1310
// module chunks = 0